import React, { useEffect } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Dialog, DialogContent, DialogTitle, DialogActions, Grid, Typography, Divider } from '@material-ui/core'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import VesselInfoFormProperties from './VesselInfoFormProperties'
import VesselInfoMakeValidationSchema from './VesselInfoMakeValidationSchema'

const {
  button: { CngButton }
} = components

function VesselInfoDialog(props) {
  const { vesselInfo, isView, onAddVesselInfo, onEditVesselInfo, open, onClose, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const title = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.TITLE)
  const saveButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.SAVE_BUTTON)

  const validationSchema = VesselInfoMakeValidationSchema(translate)

  const methods = useForm({
    defaultValues: VesselInfoFormProperties.formikProps.initialValues,
    resolver: yupResolver(validationSchema)
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    if (open) {
      if (vesselInfo) {
        reset(vesselInfo)
      } else {
        reset(VesselInfoFormProperties.formikProps.initialValues)
      }
    }
  }, [open, vesselInfo])

  function onSubmit(data) {
    if (vesselInfo) {
      onEditVesselInfo(data)
    } else {
      onAddVesselInfo(data)
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography variant="h5">
          <strong>{title}</strong>
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <FormProvider {...methods}>
          <form>
            <VesselInfoFormProperties.Fields disabled={isView} />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <CngButton color="secondary" onClick={onClose} size="medium">
          Cancel
        </CngButton>
        {!isView && (
          <CngButton color="primary" onClick={handleSubmit(onSubmit)} size="medium">
            {vesselInfo ? 'Update' : saveButton}
          </CngButton>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default VesselInfoDialog
